<script lang="ts" setup>
import helpers from '~/helpers'

defineProps<{
  categoriesData?: any[],
  tagsData?: any[]
}>()

const router = useRouter()

async function routeTo (categoryData: any): Promise<void> {
  await router.push(helpers.getCategoryPath(categoryData))
}
</script>

<template>
  <Carousel class="text-sm font-medium leading-5" :show-buttons="false">
    <div class="-ml-2 flex">
      <div
        v-for="x in categoriesData"
        :key="x.id"
        class="ml-2 inline-block cursor-pointer select-none whitespace-nowrap rounded-xl bg-main-very-light-gray px-2 py-1 text-main-dark"
        @click="routeTo(x)"
      >
        {{ x.attributes.name }}
      </div>

      <div
        v-for="x in tagsData"
        :key="x.id"
        class="ml-2 inline-block select-none whitespace-nowrap rounded-xl bg-main-green px-2 py-1 text-main-very-light-gray"
        :style="x.attributes.backgroundColor ? `background-color: ${x.attributes.backgroundColor}` : ''"
      >
        {{ x.attributes.name }}
      </div>
    </div>
  </Carousel>
</template>
